import React from 'react';

const Landing = () => (
  <div>
    Landing!
    Welcome!
  </div>
)

export default Landing;



// WEBPACK FOOTER //
// ./src/components/Landing.js